{
  "slug": "what-is-the-average-iq",
  "title": "¿Cuál es el IQ promedio?",
  "description": "Comprende por qué el IQ promedio suele fijarse en 100, cómo funcionan los percentiles y por qué las comparaciones necesitan contexto.",
  "summary": "En la mayoría de las escalas modernas, el promedio se fija en 100. Aproximadamente dos tercios del grupo normativo se sitúan entre 85 y 115.",
  "category": "Conceptos esenciales de IQ",
  "sections": [
    {
      "heading": "Por qué el promedio es 100",
      "paragraphs": [
        "Las puntuaciones se estandarizan comparando los resultados brutos con una muestra normativa. No significan que una persona haya contestado 100 preguntas correctamente.",
        "Las pruebas se renormalizan con el tiempo; por eso el nombre, la edición, la edad y el grupo normativo son importantes."
      ]
    },
    {
      "heading": "La franja habitual de 85 a 115",
      "paragraphs": [
        "Con una desviación estándar de 15, cerca del 68 % de una distribución normal se encuentra entre 85 y 115. Un resultado de 100 se aproxima al percentil 50.",
        "Los percentiles describen una posición relativa, no el porcentaje de respuestas correctas."
      ]
    },
    {
      "heading": "Comparar con cautela",
      "paragraphs": [
        "El idioma, la educación, la salud, el acceso y las condiciones pueden influir. Las comparaciones entre países son especialmente sensibles al muestreo y a la metodología.",
        "Para una persona, el intervalo de confianza y el perfil de subpruebas ofrecen más información que tratar el total como perfectamente preciso."
      ]
    }
  ],
  "faqs": [
    {
      "question": "¿100 es un buen IQ?",
      "answer": "Es el centro habitual del grupo normativo y representa un rendimiento típico en las capacidades evaluadas."
    },
    {
      "question": "¿La mitad de las personas supera 100?",
      "answer": "Aproximadamente sí en una distribución normativa centrada, aunque los datos reales no son perfectamente simétricos."
    }
  ],
  "related": ["iq-score-ranges-explained", "average-iq-in-argentina", "how-is-iq-measured"],
  "sources": [
    {
      "label": "APA Dictionary of Psychology — IQ",
      "url": "https://dictionary.apa.org/iq"
    }
  ]
}
